export const adPointBlue = {
    50: "#e0f5fc",
    100: "#b2e7f7",
    200: "#7fd7f1",
    300: "#4bc7e9",
    400: "#24bce1",
    500: "#08b1da",
    600: "#00a2c6",
    700: "#008eab",
    800: "#007a93",
    900: "#005866",
    A100: "#c2c7f1",
    A200: "#98a3e8",
    A400: "#4663d9",
    A700: "#0034ba",
};

export const adPointDarkBlue = {
    50: "#e6effe",
    100: "#c8d9e9",
    200: "#abbed3",
    300: "#8da4bc",
    400: "#768faa",
    500: "#5f7c9a",
    600: "#516e88",
    700: "#425a71",
    800: "#33475b",
    900: "#213243",
    A100: "#b7eaed",
    A200: "#8bdce2",
    A400: "#54c2ce",
    A700: "#42939b",
};

export const selectionYellow = "#fff9c4";

export const emptyListTextColor = "#909081";

export const approveGreen = "#43b64a";
export const approveGreenHover = "#099228";
export const approveGreenDisabled = "#a7c8a3";

export const secondaryBlue = "#00a3c6";
export const secondaryBlueClicked = "#0082A4";

export const formatLabelTextColor = "#ededed";
export const formatLabelBgColor = "#6A6A6A";
